import {attr, Model} from 'redux-orm';
import {createAction} from '@reduxjs/toolkit';
import {isTimestampExpired} from '../../common/helper';

const OLDER_THAN_FIVE_MINS = 275400; //4.59s in ms
const OLDER_THAN_24H = 8.64e+7; //24h in ms


const defineMovingStatus = (status) => status > 0;

const defineLocationStatus = (timestamp, status) => {

    if (isTimestampExpired(timestamp, OLDER_THAN_FIVE_MINS)) {

        if (isTimestampExpired(timestamp, OLDER_THAN_24H)) {
            return 'OLDER_THAN_24H';
        }

        return 'OLDER_THAN_FIVE_MINS';
    }

    if (defineMovingStatus(status)) {
        return 'MOVING';
    }

    return 'ONLINE';
};

const definePermissionIssues = (statuses) => {
    const {
        sign_out,
        push_service_disabled,
        geo_services_disabled,
        background_refresh_disabled,
        incognito_mode
    } = statuses;

    if (incognito_mode) {
        return 'INCOGNITO';
    }

    if (sign_out || push_service_disabled || geo_services_disabled || background_refresh_disabled) {
        return 'PERMISSIONS';
    }

    return null;
};

// =====ACTIONS=====
export const createLocations = createAction('models/locations/create');
export const updateLatLngFromFirebase = createAction('models/locations/updateLatLngFromFirebase');
export const refreshLocations = createAction('models/locations/refreshLocations');
export const clearLocations = createAction('models/locations/clearLocations');

// =====MODEL=====

class Locations extends Model {
    static modelName = 'Locations';
    static locationStatus = attr();

    static reducer({type, payload}, Locations, session) {
        switch (type) {
            case createLocations.type: {

                payload.forEach(item => {
                    Locations.upsert({
                        id: item.user_id,
                        ...item,
                        locationStatus: item.location ? defineLocationStatus(item?.location.creation_time) : null,
                        permissionsIssues: definePermissionIssues(item.statuses),
                    });
                });
                break;
            }
            case refreshLocations.type: {

                payload.forEach(item => {

                    if (!item.location) {
                        Locations.upsert({
                            id: item.user_id,
                            ...item.statuses,
                            permissionsIssues: definePermissionIssues(item.statuses),
                        });
                    } else {
                        const currentLocationsObj = Locations.withId(item.id);

                        const currentTimestamp = currentLocationsObj.location ? currentLocationsObj.location.creation_time : 0; //0 for no locations in the history

                        if (currentTimestamp < item?.location.creation_time) {
                            Locations.upsert({
                                id: item.user_id,
                                ...item,
                                locationStatus: defineLocationStatus(item.location.creation_time),
                                permissionsIssues: definePermissionIssues(item.statuses),
                            });
                        } else {

                            Locations.upsert({
                                id: item.user_id,
                                ...item.statuses,
                                permissionsIssues: definePermissionIssues(item.statuses),
                                locationStatus: defineLocationStatus(item.location.creation_time),
                            });
                        }

                    }

                });
                break;
            }

            case updateLatLngFromFirebase.type: {
                const currentLocationsObj = Locations.withId(payload.id);

                const currentTimestamp = currentLocationsObj?.location ? currentLocationsObj.location.creation_time : 0;

                if (payload.firebaseResponse.t > currentTimestamp) {
                    Locations.upsert({
                        id: payload.id,
                        location: {
                            latitude: payload.firebaseResponse.i,
                            longitude: payload.firebaseResponse.g,
                            accuracy: payload.firebaseResponse.a,
                            creation_time: payload.firebaseResponse.t,
                        },
                        locationStatus: defineLocationStatus(payload.firebaseResponse.t, payload.firebaseResponse.m),
                    });
                }

                break;
            }
            case clearLocations.type: {
                Locations.delete();
                break;
            }

            default:
                break;
        }
    }
}

export default Locations;


